<template>
  <div class="flex flex-col">
    <span class="text-lg font-semibold text-gray-900 text-left mb-4">
      Your Current Payment Method
    </span>
    <div class="flex flex-col">
      <div v-if="source === 'credit_card'" class="flex flex-row gap-2">
        <div v-html="CARD_ICON"></div>
        <span class="text-gray-800 text-md leading-6 text-left">{{
          cardNumber
        }}</span>
      </div>
      <span
        v-if="source === 'credit_card'"
        class="text-gray-800 text-md leading-6 text-left"
      >
        Expiration Date:
        <span class="text-gray-500 text-md leading-6 text-left">{{
          cardExpiry
        }}</span>
      </span>
      <div v-if="source === 'invoice'" class="flex flex-col">
        <div class="flex flex-row gap-1">
          <div v-html="DOCUMENT_DOLLAR_ICON"></div>
          <span class="text-gray-800 text-md font-semibold leading-6 text-left">
            Invoice will be mailed to:
            <span class="text-gray-500 text-md leading-6 text-left">{{
              invoiceRecipientEmail
            }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import {
  CARD_ICON,
  DOCUMENT_DOLLAR_ICON,
} from "@/assets/svg/shared/svg-constants";

export default defineComponent({
  name: "CurrentPaymentMethodModal",
  props: {
    source: { type: String, required: true },
    cardNumber: { type: String as PropType<string | null>, default: null },
    cardExpiry: { type: String as PropType<string | null>, default: null },
    invoiceRecipientEmail: {
      type: String as PropType<string | null>,
      default: null,
    },
  },
  setup() {
    return {
      CARD_ICON,
      DOCUMENT_DOLLAR_ICON,
    };
  },
});
</script>
